/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCurrencyFile = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V12h-2V9h-5V4H6v16h4v2H4zm11 3.414V7h1.586z" />
        <path d="M14.68 16.445a2.448 2.448 0 0 0-.583.305c.116.088.305.197.584.305.588.23 1.424.398 2.395.437a10.702 10.702 0 0 0 .952-.005c.927-.046 1.725-.211 2.292-.432a2.45 2.45 0 0 0 .583-.305 2.448 2.448 0 0 0-.584-.305C19.647 16.183 18.651 16 17.5 16s-2.147.183-2.82.445zm8.32.305v3.5c0 .616-.325 1.094-.677 1.417-.35.323-.803.568-1.279.752-.956.372-2.21.581-3.544.581s-2.588-.208-3.544-.58c-.475-.185-.928-.43-1.28-.753-.351-.323-.676-.801-.676-1.417v-3.5c0-.616.325-1.094.677-1.417.35-.323.804-.568 1.279-.752.956-.372 2.21-.581 3.544-.581s2.588.209 3.544.58c.475.185.928.43 1.28.753.351.323.676.801.676 1.417zm-4.882 2.735a12.6 12.6 0 0 1-1.114.005c-1.127-.044-2.174-.238-3.004-.553v1.228a.6.6 0 0 0 .03.03c.105.096.311.229.65.36.673.262 1.67.445 2.82.445 1.151 0 2.148-.183 2.82-.444.339-.132.545-.265.65-.36a.604.604 0 0 0 .03-.03v-1.23c-.8.305-1.802.496-2.882.549z" />
      </g>
    </g>
  </Icon>
);
export { SvgCurrencyFile as CurrencyFile };
